import React from 'react';
import { motion } from 'framer-motion';
import * as LuIcons from 'react-icons/lu';
const { LuSparkles, LuSearch, LuShieldCheck, LuTags } = LuIcons;
import SafeIcon from './SafeIcon';

export default function LoadingState() {
  const steps = [
    { icon: LuSearch, text: "Scanning 10,000+ stores..." },
    { icon: LuTags, text: "Finding active coupon codes..." },
    { icon: LuShieldCheck, text: "Verifying seller trust scores..." },
    { icon: LuSparkles, text: "Generating AI recommendation..." }
  ];

  return (
    <div className="min-h-[80vh] flex flex-col items-center justify-center relative overflow-hidden bg-slate-50">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-blue-100 rounded-full blur-3xl opacity-50 animate-pulse" />
      
      <div className="relative z-10 w-full max-w-md mx-auto px-4">
        <motion.div 
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          className="bg-white rounded-3xl shadow-xl shadow-blue-900/5 border border-gray-100 p-8 flex flex-col items-center"
        >
          <div className="relative w-20 h-20 mb-8">
            <svg className="animate-spin w-full h-full text-blue-100" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <div className="absolute inset-0 flex items-center justify-center">
              <SafeIcon icon={LuSparkles} className="text-blue-600 text-2xl" />
            </div>
          </div>

          <h3 className="text-xl font-bold text-gray-900 mb-2">Analyzing Product</h3>
          <p className="text-gray-500 text-sm mb-8 text-center">Our AI is doing the heavy lifting to find you the best deal.</p>

          <div className="w-full space-y-4">
            {steps.map((step, index) => (
              <motion.div 
                key={index}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: index * 0.8 }}
                className="flex items-center gap-3 text-sm font-medium text-gray-600"
              >
                <div className="w-6 h-6 rounded-full bg-blue-50 flex items-center justify-center shrink-0">
                  <SafeIcon icon={step.icon} className="text-blue-600 text-xs" />
                </div>
                {step.text}
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </div>
  );
}